import { render, staticRenderFns } from "./UserAvatarUpload.vue?vue&type=template&id=2dbc9627&scoped=true&"
import script from "./UserAvatarUpload.vue?vue&type=script&lang=js&"
export * from "./UserAvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarUpload.vue?vue&type=style&index=0&id=2dbc9627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc9627",
  null
  
)

export default component.exports